import * as types from './mutations-type'
import AccountService from '../service/account.service'
import ConfigService from '../service/config.service'

const actions = {
  /**
   * 获取当前时间戳
   */
  getNowTime ({ state, commit }) {
    return ConfigService.getTime().then(res => {
      commit(types.SET_NOW_TIME, res.time)
      return res
    })
  },
  /**
   * 获取 Layout 导航数据
   */
  getLayoutNav ({ state, commit }) {
    return ConfigService.getNavList().then(res => {
      commit(types.SET_LAYOUT_NAV, {
        notice: res.notice,
        header: res.top,
        footer: res.bot,
        bus: res.bus
      })
      return res
    })
  },
  /**
   * 获取用户信息
   */
  getSigninInfo ({ state, commit }) {
    return AccountService.getSigninInfo().then(res => {
      commit(types.LOGIN, res)
      return res
    })
  },
  /**
   * 登出
   */
  logout ({ state, commit }) {
    return AccountService.logout().then(res => {
      commit(types.LOGOUT)
      location.reload()
      return true
    }).catch(() => {
      commit(types.LOGOUT)
      location.reload()
      return true
    })
  },
  /**
   * 获取手机区号列表
   */
  getPhoneList ({ state, commit }) {
    return ConfigService.getPhoneList().then(res => {
      commit(types.SET_PHONE_LIST, res)
      return res
    })
  },
  /**
   * 触发页面中的回调动作
   */
  getPageAction ({state, commit}, cb) {
    if (state.pageAction) {
      cb && cb(state.pageAction)
    }
    commit(types.SET_PAGE_ACTION, null)
  }
}

export default actions
